import { StyleSheet } from 'react-native';
import { colors, fonts, spacings } from '@views/shared/styles';

const {
  big,
  extraSmall,
  huge,
  medium,
  oversize,
  small,
  smaller,
  smallMedium,
  tiny,
  verySmall,
} = spacings;
const { aquaMarine, black, blackAlpha, warmPink, white } = colors;
const { sizeDefault, sizeSmall, sizeSmallPlus } = fonts;

export const styles = StyleSheet.create({
  container: {
    borderColor: blackAlpha,
    borderWidth: 1,
    borderRadius: extraSmall,
    paddingHorizontal: oversize,
    marginTop: oversize,
    paddingBottom: huge,
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    marginBottom: extraSmall,
    marginTop: medium,
  },
  titleOrderContainer: {
    marginBottom: smaller,
    marginTop: 0,
  },
  title: {
    fontSize: sizeDefault,
    fontFamily: 'mrt-semi-bold',
  },
  titleIcon: {
    marginTop: -1,
    marginLeft: medium,
  },
  titleIconSmall: {
    marginLeft: 0,
    marginRight: verySmall,
  },
  description: {
    fontSize: sizeSmallPlus,
    fontFamily: 'mrt-regular',
    marginBottom: extraSmall,
  },
  item: {
    fontSize: sizeSmallPlus,
    fontFamily: 'mrt-regular',
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    paddingTop: small,
  },
  itemButton: {
    borderColor: blackAlpha,
    borderRadius: smaller,
    borderWidth: 1,
    backgroundColor: white,
    height: 30,
    width: 30,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  itemButtonTitle: {
    fontSize: 40,
    paddingBottom: verySmall,
    lineHeight: 30,
    color: black,
    fontFamily: 'mrt-regular',
    marginTop: 1,
    width: 40,
  },
  itemButtonTitlePlus: {
    fontSize: 30,
    paddingBottom: 0,
    marginTop: -1,
  },
  itemRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: tiny,
  },
  quantityContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  quantityText: {
    width: 36,
    textAlign: 'center',
    fontSize: sizeDefault,
    fontFamily: 'mrt-semi-bold',
  },
  error: {
    color: warmPink,
    fontFamily: 'mrt-semi-bold',
    marginTop: verySmall,
    fontSize: sizeSmallPlus,
  },
  errorOrder: {
    marginTop: verySmall,
  },
  success: {
    color: aquaMarine,
  },
  orderContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  cancelButton: {
    paddingHorizontal: 0,
    paddingVertical: 0,
    padding: 0,
  },
  orderItem: {
    fontSize: sizeSmall,
    fontFamily: 'mrt-regular',
  },
  itemText: { flex: 1 },
  orderedItems: {
    marginTop: small,
    paddingTop: small,
    borderColor: blackAlpha,
    borderTopWidth: 1,
  },
  divider: {
    borderColor: blackAlpha,
    borderTopWidth: 1,
    paddingTop: smallMedium,
    marginTop: big,
  },
  bookingDisableContainer: {
    marginTop: smallMedium,
    fontSize: sizeSmallPlus,
    fontFamily: 'mrt-regular',
    color: warmPink,
  },
  bookingsOverview: {
    paddingLeft: 50,
  },
  orderedItemsBookingsOverview: {
    borderTopWidth: 0,
    paddingTop: 0,
    marginTop: extraSmall,
  },
});
